import { HttpParams } from '@angular/common/http';

/** Params de listado compartidos por catálogos country-scoped (patrón areas). */
export function buildCountryTitleListParams(args: {
  page?: number;
  size?: number;
  sort?: string;
  direction?: 'asc' | 'desc';
  search?: string;
  status?: string;
}): HttpParams {
  let params = new HttpParams()
    .set('page', String(args.page ?? 0))
    .set('size', String(args.size ?? 20))
    .set('sort', args.sort ?? 'createdAt')
    .set('direction', args.direction ?? 'desc');

  if (args.search?.trim()) {
    params = params.set('search', args.search.trim());
  }
  if (args.status?.trim()) {
    params = params.set('status', args.status.trim().toUpperCase());
  }
  return params;
}

/**
 * Payload API del flatten (prefix/code/name/status).
 * Acepta `title`/`name` desde UI legacy y lo manda como `name`.
 */
export function toCountryTitleApiPayload(payload: {
  name?: string;
  title?: string;
  code?: string;
  prefix?: string;
  status?: string;
  detail?: boolean;
  document?: boolean;
  subject?: boolean;
}): Record<string, string | boolean> {
  const body: Record<string, string | boolean> = {
    name: (payload.name ?? payload.title ?? '').trim(),
  };
  const prefix = (payload.prefix ?? '').trim();
  if (prefix) {
    body['prefix'] = prefix;
  }
  const code = (payload.code ?? '').trim();
  if (code) {
    body['code'] = code;
  }
  if (payload.status != null && payload.status !== '') {
    body['status'] = String(payload.status).toUpperCase();
  }
  if (payload.detail !== undefined) {
    body['detail'] = !!payload.detail;
  }
  if (payload.document !== undefined) {
    body['document'] = !!payload.document;
  }
  if (payload.subject !== undefined) {
    body['subject'] = !!payload.subject;
  }
  return body;
}

export function normalizeCountryTitleStatus(
  status: string | undefined,
): 'active' | 'inactive' {
  if (!status) return 'active';
  return status.toLowerCase() as 'active' | 'inactive';
}

/** Mapeo común de ítem API → UI (compat title↔name). */
export function mapCountryCatalogItem(it: any): {
  id: string;
  prefix: string;
  code: string;
  name: string;
  title: string;
  status: 'active' | 'inactive';
  createdAt?: string;
} {
  const name = String(it?.name ?? it?.title ?? '');
  const prefix = String(it?.prefix ?? '');
  const code = String(it?.code ?? prefix);
  return {
    id: String(it?.id ?? ''),
    prefix,
    code,
    name,
    title: name,
    status: normalizeCountryTitleStatus(it?.status),
    createdAt: it?.createdAt || it?.created_at || undefined,
  };
}
